import { getTaskById } from "@/api/tasks/getTaskById";
import { useQuery } from "@tanstack/react-query";

export const useGetTaskById = (taskId: string) => {
  return useQuery({
    queryKey: ['task', taskId],
    queryFn: () => getTaskById(taskId),
    enabled: !!taskId,
    staleTime: 1000 * 60 * 5, // 5 minutos
    gcTime: 1000 * 60 * 10, // 10 minutos
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
}; 